import React from "react";
import { ColorBox } from "../../components/color-box";

export const FormStatusRenderer = ({ color, text } = {}) => (
  <ColorBox color={color} title={text} />
);
